export default {"src":"/_next/static/media/reCAPTCHA.bb599b9f.svg","height":62,"width":66,"blurWidth":0,"blurHeight":0};